import styled from 'styled-components';

export const Description = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #b4b9d9;
  text-align: left;
  position: relative;
  padding: 10px 0;
  width: 100%;
`;
